<template>
  <div id="hj-container">
    <header-layout activeIndex="index"></header-layout>
    <div id="home">
      <el-carousel :interval="5000" height="200px">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <el-image :src="item" fit="cover"> </el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="container2 pb10" id="aboutUs">
      <el-image :src="container2Url"></el-image>
      <div class="el-card-text pl20 pr20"><span class="text-bold font17">因朔桔(上海)智能科技有限公司</span>(以下简称“因朔桔科技”)成立于2018年，致力于人工智能在保险行业的应用场景落地，以智能算法引擎为基础的HiMind平台，基于长期积累的保险及医疗知识数据库，通过高精准指令进行多模态预训练，打造了拥有高质量保险医疗语义理解能力的Ai保险大模型，服务保险产品设计，理赔风控，客户运营和客户营销全生命周期。</div>
      <div class="el-card-text pl20 pr20 pt20">因朔桔HiMind智能平台，沉淀行业应场景数据和用户理赔、医疗数据，分析学习用户行为偏好，链接线上线下医疗资源，为保司定制健康险产品和健康权益服务，并对客户进行智能营销，提升保险销售转化，提升保司健康管理服务水平，增强用户黏性。</div>
    </div>
    <div class="container3">
      <el-image :src="w_05" class="mt10"> </el-image>
      <div></div>
      <!--      <div class="serviceItem">-->
      <div class="hj-el-card">
        <i class="el-card-image healthy"></i>
        <p class="hj-el-card-content-title">保险产品设计与健管服务</p>
        <div class="hj-el-card-content">
          <div class="bottom clearfix">
            <p class="el-card-text">木吉健康是因朔桔旗下健康管理品牌，致力于链接药企，医疗机构等大健康资源，结合因朔桔产品设计，理赔风控，风险定价的能力，为保险客户构建专业的健康服务平台，提供健康险产品与健康管理权益服务，打造保险+医疗闭环能力。</p>
          </div>
        </div>
        <el-image :src="bg2" fit="cover" class="item-img"></el-image>
      </div>
      <div class="hj-el-card">
        <i class="el-card-image pay"></i>
        <p class="hj-el-card-content-title">理赔控费平台</p>
        <div class="hj-el-card-content">
          <div class="bottom clearfix">
            <p class="el-card-text">致力于打造智能化的理赔控费运营平台，基于NLP技术与医疗知识图谱的医疗数据标准化服务及大数据建模的理赔费用风险分析模型，提供高效率高精度的理赔风控运营。理赔控费减损效果可达10%-30%。</p>
          </div>
        </div>
        <el-image :src="bg3" fit="cover" class="item-img"></el-image>
      </div>
      <div class="hj-el-card">
        <i class="el-card-image add"></i>
        <p class="hj-el-card-content-title">数字化赋能</p>
        <div class="hj-el-card-content">
          <div class="bottom clearfix">
            <p class="el-card-text">因朔桔自主研发的团险核心业务SaaS平台、健康服务管理平台、健康险数据中台等数字化平台，赋能客户解决传统保险业务痛点，改善用户体验，提升管理效率。</p>
          </div>
        </div>
        <el-image :src="bg1" fit="cover" class="item-img"></el-image>
      </div>
      <!--      </div>-->
    </div>
    <div class="container4"></div>
    <div class="container5" id="honour">
      <el-image :src="w_12"></el-image>
      <div style="margin: 0 10px 20px">
        <el-carousel :interval="10000" height="200px">
          <el-carousel-item v-for="item in ryList" :key="item">
            <el-image :src="item" fit="cover"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
<!--      <el-image :src="w_23"></el-image>-->
    </div>
    <div class="joinUs-list">
      <div class="joinUs-list-head">
        <div class="head-img-row">
          <div class="head-img"></div>
          <div style="margin-left: -15px">岗位介绍</div>
        </div>
        <div class="mt10">
          <div class="text-bold font20">因朔桔（上海）智能科技有限公司</div>
          <div class="font14 text-line-height">（致力于构建 “保险+健康服务” 的保险大健康平台）</div>
        </div>
        <div class="mt20 flex justify-between">
          <div>
            <el-radio-group v-model="radio1" fill="#FF8E3E" size="small">
              <el-radio-button label="上海"></el-radio-button>
              <el-radio-button label="西安"></el-radio-button>
              <el-radio-button label="其他"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="latest-release">最新发布<img src="../../assets/img/home/down.png" class="pl5" /></div>
        </div>
      </div>
      <el-carousel height="500px" indicator-position="none">
        <el-carousel-item v-for="(item, i) in list" :key="i">
          <div class="job-list">
            <div style="z-index: 99; position: relative">
              <h3>{{ item.title }}</h3>
              <p v-for="(word, index) in item.concent" :key="index">{{ word }}</p>
            </div>
            <div class="job-img" :style="{ backgroundImage: 'url(' + item.url + ')' }"></div>
            <el-button class="job-button" @click="centerDialogVisible = true">我要投递</el-button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <el-dialog title="" :visible.sync="centerDialogVisible" width="100%" center>
      <div class="text-center">
        <div class="text-bold font28" style="color: #20578f; line-height: 100px">想要了解更多岗位？</div>
        <div class="text-bold font22" style="line-height: 40px">欢迎发送你的简历到</div>
        <div class="text-bold font20" style="color: #ff8f41; line-height: 40px">hr@insuresmart.com.cn</div>
        <div class="mb40">(邮件标题:地点+职位+名字)</div>
      </div>
    </el-dialog>
    <div style="padding: 0" id="footerLayout">
      <el-footer style="padding: 0">
        <footer-layout></footer-layout>
      </el-footer>
    </div>
  </div>
</template>

<script>
import HeaderLayout from '@/components/mobile/HeaderLayout.vue'
import FooterLayout from '@/components/mobile/FooterLayout.vue'

export default {
  name: '',
  components: { HeaderLayout, FooterLayout },
  data() {
    return {
      centerDialogVisible: false,
      activeIndex: '',
      bannerList: [require('../../assets/img/home/banner1.jpg'), require('../../assets/img/home/banner2.jpg'), require('../../assets/img/home/banner3.jpg')],
      ryList: [require('../../assets/img/home/ry1.png'), require('../../assets/img/home/ry2.png')],
      container2Url: require('../../assets/img/home/aboutysj_m.jpg'),
      w_05: require('../../assets/img/home/w_05_m.jpg'),
      w_23: require('../../assets/img/home/w_23_m.png'),
      w_12: require('../../assets/img/home/w_12_m.jpg'),
      a_42: require('../../assets/img/home/a_42_m.png'),
      bg1: require('../../assets/img/home/bg1.jpg'),
      bg2: require('../../assets/img/home/bg2.jpg'),
      bg3: require('../../assets/img/home/bg3.jpg'),
      list: [
        {
          title: 'Java开发工程师(中高级)',
          concent: ['1、参与业务产品或项目的需求分析及可行性评估,提供技术方案;', '2、根据业务需求和技术规范,负责系统的详细设计及核心代码的编写;', '3、解决开发过程中的技术问题;', '4、协助完成项目交付的测试、运维交付工作,对项目实施和日常业务运营提供技术支持;', '5、遵守公司的开发规范,高效、高质量地完成其他相关工作任务。'],
          url: require('../../assets/img/home/bg123.png')
        },
        {
          title: '自动化测试专员',
          concent: ['1、负责自动化测试项目实施,框架搭建和维护,脚本开发和执行测试任务,bug监控和反馈;', '2、自动化测试项目推广,包括制定测试实施计划,脚本质量监控;', '3、技术支持,解决自动化测试实施中遇到的问题;', '4、设计自动化测试用例。'],
          url: require('../../assets/img/home/bg129.png')
        },
        {
          title: '技术总监/保险软件',
          concent: ['1、制订技术架构标准、开发管理模式、质量管理体系,并负责在技术部门内部推进, 承担开发现场管理职责;', '2、根据业务发展规划,制订业界领先、具有竞争力的技术解决方案;', '3、组织开发团队高质量、高效率地完成开发交付工作;', '4、保证系统上线后稳定运行,支撑业务有序开展;', '5、负责技术人员的招聘、培训、考核等相关工作。'],
          url: require('../../assets/img/home/bg125.png')
        }
      ],
      radio1: '上海'
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.container3 {
  background-color: #f7f8fc;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .hj-el-card {
    width: 350px;
    margin: 0 40px;

    &:hover {
      .el-card-image {
        &.healthy {
          background-image: url('../../assets/img/home/healthy-active.png');
        }

        &.pay {
          background-image: url('../../assets/img/home/pay-active.png');
        }

        &.add {
          background-image: url('../../assets/img/home/add-active.png');
        }
      }

      .item-img {
        opacity: 1;
      }
    }
  }

  .el-card-image {
    display: inline-block;
    width: 73px;
    height: 76px;
    background-repeat: no-repeat;

    &.healthy {
      background-image: url('../../assets/img/home/healthy-icon.png');
    }

    &.pay {
      background-image: url('../../assets/img/home/pay-icon.png');
    }

    &.add {
      background-image: url('../../assets/img/home/add-icon.png');
    }
  }

  .hj-el-card-content-title {
    margin-bottom: 10px;
    font-size: 20px;
  }

  .hj-el-card-content {
    background-color: #ffffff;
    padding: 10px 20px;
    //height: 120px;
  }

  .item-img {
    opacity: 0.5;
    width: 350px;
    height: 226px;
  }
}

.el-card-text {
  color: #606266;
  font-size: 14px;
  text-align: justify;
  line-height: 28px;
}

.container6 {
  .a_42_bg {
    width: 100%;
    height: 130px;
    background-image: url('../../assets/img/home/a_42_m.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

.joinUs-list {
  background-color: #f3f5f7;
  padding: 15px 0;

  .joinUs-list-head {
    padding: 0px 10px 20px;

    .head-img-row {
      line-height: 40px;
      font-size: 22px;
      font-weight: bold;
      color: #20578f;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .head-img {
      width: 30px;
      height: 30px;
      background-image: url('../../assets/img/home/001.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .job-img {
    z-index: 0;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200px;
    height: 200px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.el-radio-button {
  margin-right: 10px;
  border-radius: 10px;
}

::v-deep .el-radio-button__inner {
  border-radius: 65px !important;
  border: none;
}
.latest-release {
  padding: 0 10px;
  line-height: 16px;
  font-size: 14px;
  border-radius: 15px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.job-list {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  height: 100%;
  text-align: left;

  h3 {
    line-height: 60px;
    font-size: 20px;
    font-weight: bold;
  }

  p {
    line-height: 30px;
  }
}
.job-button {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background-color: #ff8e3e;
  color: #ffffff;
  border-radius: 20px;
  border: none;
}
</style>
